var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98 10.554h1.864v7.672c0 .151.123.274.274.274h3.16a.274.274 0 00.274-.274V10.59h2.142c.14 0 .257-.104.272-.242l.326-2.825a.274.274 0 00-.272-.305h-2.468v-1.77c0-.535.287-.805.854-.805h1.614a.274.274 0 00.274-.274V1.776a.274.274 0 00-.274-.274h-2.224c-.016 0-.05-.002-.102-.002-.386 0-1.726.076-2.786 1.05-1.173 1.08-1.01 2.373-.971 2.597v2.07H5.98a.274.274 0 00-.274.275v2.788c0 .151.123.274.274.274z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;